import { render, staticRenderFns } from "./NuevoPedido.vue?vue&type=template&id=18d92c42&"
import script from "./NuevoPedido.vue?vue&type=script&lang=js&"
export * from "./NuevoPedido.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports